import {
	fireErrorAnalytics,
	type AnalyticsPayload,
} from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { getTenantAttributes } from './getTenantAttributes.tsx';

export const fireErrorAnalyticsCommon = (payload: AnalyticsPayload): void => {
	const { skipSentry = true, attributes, ...otherPayload } = payload;

	fireErrorAnalytics({
		...otherPayload,
		attributes: {
			...attributes,
			...getTenantAttributes(),
		},
		// skiping sentry as true for fireErrorAnalytics
		skipSentry,
	});
};
